import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "../../utils/index.js";
import { popupHeaderVariants } from "./PopupHeader.variants.js";
const PopupHeader_Content_PopupHeaderContent = /*#__PURE__*/ forwardRef(function({ className, children, ...props }, ref) {
    const { content } = popupHeaderVariants();
    return /*#__PURE__*/ jsx("div", {
        ref: ref,
        className: cn(content(), className),
        ...props,
        children: children
    });
});
PopupHeader_Content_PopupHeaderContent.displayName = 'PopupHeader.Content';
export { PopupHeader_Content_PopupHeaderContent as PopupHeaderContent };
